import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { GraduationCap, ArrowRight } from "lucide-react";
import { HubCard } from "@/components/hub/HubCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function HubPreviewSection() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/hub/content`, { params: { limit: 6 } }).then((r) => {
      const all = r.data?.items || [];
      const featured = all.filter((i) => i.featured);
      const rest = all.filter((i) => !i.featured);
      setItems([...featured, ...rest].slice(0, 3));
    }).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="iw-grid-bg bg-surface-light py-12" data-testid="hub-preview-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
          <div>
            <p className="font-mono text-xs font-bold uppercase text-brand-red mb-2 flex items-center gap-2">
              <GraduationCap className="w-4 h-4" /> Wellness Hub
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl text-navy font-bold">Learn something useful this week</h2>
            <p className="font-body text-gray-500 text-base mt-1">Practical wellness education — articles, videos, and guides from our editorial team.</p>
          </div>
          <Link to="/wellness-hub"
            className="flex items-center gap-1.5 font-mono text-[10px] uppercase font-semibold text-brand-blue hover:text-navy transition-colors"
            data-testid="hub-preview-see-all">
            Visit the Hub <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((item) => <HubCard key={item.id} item={item} />)}
        </div>
      </div>
    </section>
  );
}
